import React, { useState, useEffect } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  isSameDay,
  addMonths,
  subMonths,
  addYears,
  subYears,
} from "date-fns";
import moment from "moment";
import "./style.scss";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";

const CalendarOne = ({ data, setSelectedDateValue }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [events, setEvents] = useState({});

  const toUTCDate = (date) => {
    return moment.utc(date).startOf("day").toDate();
  };



  useEffect(() => {
    if (!data) return;

    const tradingProfits = {};

    // Determine the source of day-wise stats based on the trading platform
    const daysStats =
      data?.trading_platform === 1
        ? data?.account_metrics?.day_wise_data?.day_stats
        : data?.account_metrics?.day_wise_data?.day_stats.map((item) => ({
          tradeDate: item?.date,
          totalPnL: item?.balance_without_fees,
          totalTrades: item?.volume,
          totalFees: item?.fees || 0, // Ensure fees are accounted for if available
        }));

    // Iterate through the stats to populate tradingProfits
    daysStats?.forEach((trade) => {
      let tradeDate;
      const dateVal = trade?.tradeDate;
      if (typeof dateVal === "string" && dateVal.length === 10 && !dateVal.includes("T")) {
        tradeDate = moment(dateVal).format("DD-MM-YYYY");
      } else {
        tradeDate = moment(dateVal).format("DD-MM-YYYY");
      }

      if (!tradingProfits[tradeDate]) {
        tradingProfits[tradeDate] = [0, 0];
      }
      tradingProfits[tradeDate] = [
        trade?.totalPnL - (trade?.totalFees || 0),
        trade?.totalTrades || 0, // Default to 0 if totalTrades is undefined
      ];
    });

    setEvents(tradingProfits);
  }, [data]);


  const renderHeader = () => (
    <div className="calendar-header">
      <button onClick={prevYear}>{"<<"}</button>
      <button onClick={prevMonth}>{"<"}</button>
      <span>{format(currentMonth, "MMMM yyyy")}</span>
      <button onClick={nextMonth}>{">"}</button>
      <button onClick={nextYear}>{">>"}</button>
    </div>
  );

  const renderDays = () => {
    const days = [];
    const startDate = startOfWeek(currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div key={i} className="day-name">
          {format(addDays(startDate, i), "E")}
        </div>
      );
    }

    return <div className="days-row">{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);
    const today = new Date();

    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";

    while (day <= endDate) {
      formattedDate = format(day, "dd-MM-yyyy");
      const cloneDay = day;
      const isFutureDate = day > today;

      const eventForDay = events[formattedDate];

      days.push(
        <div
          className={`col cell ${!isSameMonth(day, monthStart) || isFutureDate
            ? "disabled"
            : isSameDay(day, selectedDate)
              ? "selected"
              : ""
            } ${eventForDay &&
            (eventForDay[0] > 0
              ? "profit-event"
              : eventForDay[0] < 0
                ? "loss-event"
                : "")
            }`}
          key={day}
          onClick={() => !isFutureDate && onDateClick(cloneDay)}
        >
          <span className="number">{format(day, "d")}</span>
          {eventForDay && (
            <div
              className={`event-title ${eventForDay[1] === "Birthday" ? "birthday" : ""
                }`}
            >
              <span>{FormatUSD(eventForDay[0])} P&L</span>
              <span>{eventForDay[1]} Trades</span>
            </div>
          )}
        </div>
      );
      day = addDays(day, 1);
    }

    rows.push(
      <div className="row" key={day}>
        {days}
      </div>
    );
    days = [];

    return <div className="body">{rows}</div>;
  };

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  const nextYear = () => {
    setCurrentMonth(addYears(currentMonth, 1));
  };

  const prevYear = () => {
    setCurrentMonth(subYears(currentMonth, 1));
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
    const utcDate = moment(day).format("DD-MM-YYYY");
    const tradeValues = data?.account_metrics?.data?.filter((item) => {
      const dateVal = item?.tradeDay || item?.date;
      const formattedDate =
        typeof dateVal === "string" && dateVal.length === 10 && !dateVal.includes("T")
          ? moment(dateVal).format("DD-MM-YYYY")
          : moment(dateVal).format("DD-MM-YYYY");
      return formattedDate === utcDate;
    });

    setSelectedDateValue(tradeValues);
  };

  return (
    <div className="calendar">
      {renderHeader()}
      {renderDays()}
      {renderCells()}
    </div>
  );
};

export default CalendarOne;
